import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Toggle from 'react-toggle';
export const FilterToggleSelect = ({ item, showOnItem, setFilter, activeFilters, label, isAlwaysVisible, tooltip, enabled, }) => ({
    filterItem: item,
    enabled: enabled,
    filterSelectLabel: !isAlwaysVisible ? label : undefined,
    element: showOnItem && !activeFilters[showOnItem] ? null : (_jsxs("label", Object.assign({ className: "react-toggle-wrapper margin10T", title: tooltip }, { children: [_jsx(Toggle, { checked: activeFilters[item], onChange: e => { var _a; return setFilter({ [item]: (_a = e.target.checked) !== null && _a !== void 0 ? _a : undefined }); } }), _jsx("span", Object.assign({ className: "label-text" }, { children: label }))] }))),
});
